import { data, type ObservableValue } from '@amazon/vinyl-observable'
import type { Disposable, Unsubscribe } from '@amazon/vinyl-util'

const FOREGROUND_SESSION_TYPE = 'foreground_session'

/** GH's foreground session: a fresh id each time the host comes to the foreground, none while hidden. */
export class ForegroundSession implements Disposable {
    private readonly _id$ = data<string | null>(null)
    readonly id$: ObservableValue<string | null> = this._id$
    private readonly unsubscribe: Unsubscribe

    constructor(hidden$: ObservableValue<boolean>) {
        this.unsubscribe = hidden$.onData((hidden) => {
            this._id$.value = hidden ? null : (this._id$.value ?? crypto.randomUUID())
        })
    }

    dispose(): void {
        this.unsubscribe()
    }
}

/** The `customSessionId`/`customSessionType` pair GH stamps on every metric of a foreground session. */
export function foregroundSessionDetails(id: string | null): Record<string, string> {
    return id === null ? {} : { customSessionId: id, customSessionType: FOREGROUND_SESSION_TYPE }
}
